"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var _wrapNativeSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var idlUtils = require("../generated/utils.js");

exports.implementation = /*#__PURE__*/function (_Array) {
  _inherits(FileListImpl, _Array);

  var _super = _createSuper(FileListImpl);

  function FileListImpl() {
    _classCallCheck(this, FileListImpl);

    return _super.call(this, 0);
  }

  _createClass(FileListImpl, [{
    key: "item",
    value: function item(index) {
      return this[index] || null;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      return this.keys();
    }
  }]);

  return FileListImpl;
}( /*#__PURE__*/_wrapNativeSuper(Array));